import axios from 'axios'

export default {
  getList (params) {
    return axios.get(`/v1/tags`, { params })
  }
}
